import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/axios'
Vue.use(Vuex)

const Shops = new Vuex.Store({
    state: {
        rs_addshop: [],
        rs_Shops: [],
        rs_getbyShops: [],
        rs_updateShops: [],
        SecretKey: [],
        ServiceApi: [],
        LinkLineNotify: [],
        rs_Transections: [],
        rs_getDashboard: [],
        rs_delete: [],
    },
    mutations: {
        // setPosts(state,posts) {
        //     state.posts = posts
        // },

        addShops(state, data) {
            state.rs_addshop = data
        },
        showShops(state, data) {
            state.rs_Shops = data
        },
        getbyShops(state, data) {
            state.rs_getbyShops = data
        },
        updateShops(state, data) {
            state.rs_updateShops = data
        },
        genarateSecretKey(state, data) {
            state.SecretKey = data
        },
        updateServiceApi(state, data) {
            state.ServiceApi = data
        },
        getLinkLineNotify(state, data) {
            state.LinkLineNotify = data
        },
        listTransections(state, data) {
            state.rs_Transections = data
        },
        getDashboard(state, data) {
            state.rs_getDashboard = data
        },
        deleteShop(state, data) {
            state.rs_delete = data
        },


    },
    actions: {
        async addShops(context, options) {
            let data = await axios.post("https://services.payremind.com/api/v2/shops/add", options, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } }).then((r) => {
                return r.data
            })
            context.commit("addShops", data)
        },
        async showShops(context, options) {
            let data = await axios.post("https://services.payremind.com/api/v2/shops/showShops", options, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } }).then((r) => {
                return r.data
            })
            context.commit("showShops", data)
        },
        async getbyShops(context, options) {
            let data = await axios.post("https://services.payremind.com/api/v2/shops/showShops/" + options.shops_id, options, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } }).then((r) => {
                return r.data
            })
            context.commit("getbyShops", data)
        },
        async updateShops(context, options) {
            let data = await axios.post("https://services.payremind.com/api/v2/shops/update/" + options.shops_id, options, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } }).then((r) => {
                return r.data
            })
            context.commit("updateShops", data)
        },
        async genarateSecretKey(context, options) {
            let data = await axios.post("https://services.payremind.com/api/v2/shops/genarateSecretKey/" + options.shops_id, options, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } }).then((r) => {
                return r.data
            })
            context.commit("genarateSecretKey", data)
        },
        async updateServiceApi(context, options) {
            let data = await axios.post("https://services.payremind.com/api/v2/shops/updateServiceApi/" + options.shops_id, options, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } }).then((r) => {
                return r.data
            })
            context.commit("updateServiceApi", data)
        },
        async getLinkLineNotify(context, options) {
            let data = await axios.post("https://services.payremind.com/api/v2/shops/notify/" + options.shops_id, options, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } }).then((r) => {
                return r.data
            })
            context.commit("getLinkLineNotify", data)
        },
        async listTransections(context, options) {
            let data = await axios.post("https://services.payremind.com/api/v2/shops/transections/" + options.shops_id, options, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } }).then((r) => {
                return r.data
            })
            context.commit("listTransections", data)
        },
        async getDashboard(context, options) {
            let data = await axios.post("https://services.payremind.com/api/v2/shops/getDashboard/" + options.shops_id, options, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } }).then((r) => {
                return r.data
            })
            context.commit("getDashboard", data)
        },
        async deleteShop(context, options) {
            let data = await axios.post("https://services.payremind.com/api/v2/shops/delete/" + options.shops_id, options, { headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } }).then((r) => {
                return r.data
            })
            context.commit("deleteShop", data)
        },


    }
})

export default Shops